module.exports = __webpack_public_path__ + "media/images/sandbox/mario--thumb-329cf73df71527ae43b16d18af8dea7e.png";